import type { SVGProps } from "react";

export function Cancel01Icon({
  width = "18",
  height = "18",
  strokeWidth = "1.125",
  props,
}: {
  width?: string;
  height?: string;
  strokeWidth?: string;
  props?: SVGProps<SVGSVGElement>;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.25 3.75L3.75 14.25M3.75 3.75L14.25 14.25"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
